module.exports = __webpack_public_path__ + "static/services-img1-c9a39cb1065014cd9dfe0ab96b630525.png";